import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mb-4 ext-attr-group" }
const _hoisted_4 = { class: "pis-heading ext-attr-group-heading" }
const _hoisted_5 = { class: "h6 mb-3" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  class: "table-responsive position-relative d-none d-md-block",
  style: {"min-height":"3rem","overflow-x":"auto"}
}
const _hoisted_8 = { class: "table table-sm table-striped" }
const _hoisted_9 = {
  key: 0,
  style: {"width":"80px"}
}
const _hoisted_10 = { class: "table-light" }
const _hoisted_11 = {
  key: 0,
  class: "text-center border-top-0 ps-4 pe-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "ms-1 me-1" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "text-center align-middle"
}
const _hoisted_15 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center",
  style: {"height":"40px"}
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center text-muted",
  style: {"height":"40px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pis-icon pis-icon-image pis-icon-lg" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 1,
  class: "fw-bold"
}
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "mt-1" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { class: "d-md-none" }
const _hoisted_29 = { class: "card-body p-3" }
const _hoisted_30 = { class: "d-flex align-items-start mb-2" }
const _hoisted_31 = {
  key: 0,
  class: "flex-shrink-0 me-3"
}
const _hoisted_32 = {
  key: 0,
  style: {"width":"60px","height":"60px"}
}
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center text-muted rounded border",
  style: {"width":"60px","height":"60px"}
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "pis-icon pis-icon-image" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "flex-grow-1 min-w-0" }
const _hoisted_38 = { class: "mb-2" }
const _hoisted_39 = {
  key: 1,
  class: "fw-bold text-break"
}
const _hoisted_40 = { class: "mb-2" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "mb-3" }
const _hoisted_43 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "text-muted d-block" }
const _hoisted_47 = {
  key: 1,
  class: "text-break"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_VRuntimeTemplate = _resolveComponent("VRuntimeTemplate")!
  const _component_Clickable = _resolveComponent("Clickable")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["pis-component mt-4", _ctx.componentName]),
    part: _ctx.componentName,
    id: "pis-anchor-variants-table"
  }, [
    (_ctx.isReady && _ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.isWebComponent)
            ? (_openBlock(), _createBlock(_component_InjectStyles, {
                key: 0,
                items: _ctx.store?.options.styles
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.t('VariantProducts')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                key: group.attributeCode,
                class: "mb-4"
              }, [
                _createElementVNode("h5", _hoisted_5, [
                  _createElementVNode("span", {
                    class: "text-muted",
                    innerHTML: group.attributeName + ': '
                  }, null, 8, _hoisted_6),
                  _createTextVNode(" " + _toDisplayString(group.attributeValueText), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _createElementVNode("colgroup", null, [
                      (_ctx.componentOptions.showImages !== false)
                        ? (_openBlock(), _createElementBlock("col", _hoisted_9))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentOptions.columns, (col, index) => {
                        return (_openBlock(), _createElementBlock("col", {
                          key: index,
                          style: _normalizeStyle({ width: col.width })
                        }, null, 4))
                      }), 128))
                    ]),
                    _createElementVNode("thead", _hoisted_10, [
                      _createElementVNode("tr", null, [
                        (_ctx.componentOptions.showImages !== false)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_11, _hoisted_13))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentOptions.columns, (col, index) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: index,
                            class: "border-top-0"
                          }, [
                            (col.headerTemplate)
                              ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                  key: 0,
                                  template: col.headerTemplate,
                                  "template-props": { t: _ctx.t, col }
                                }, null, 8, ["template", "template-props"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(col.caption), 1)
                                ], 64))
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.products, (product) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: `${group.attributeCode}-${product.productId}`
                        }, [
                          (_ctx.componentOptions.showImages !== false)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                                (product.images?.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                      _createElementVNode("img", {
                                        src: product.images[0].thumbnailUrl,
                                        class: "img-fluid",
                                        style: {"max-height":"40px","object-fit":"contain"}
                                      }, null, 8, _hoisted_16)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentOptions.columns, (col, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: index,
                              class: "align-middle"
                            }, [
                              (col.cellTemplate)
                                ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                    key: 0,
                                    template: col.cellTemplate,
                                    "template-props": {
                        col,
                        group,
                        item: product,
                        instance: _ctx.instance,
                        t: _ctx.t,
                        attrValue: _ctx.attrValue,
                        details: _ctx.details,
                      }
                                  }, null, 8, ["template", "template-props"]))
                                : (col.dataField === 'ProductName')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      (product.productId)
                                        ? (_openBlock(), _createBlock(_component_Clickable, {
                                            key: 0,
                                            onClick: ($event: any) => (_ctx.details(product)),
                                            class: "text-decoration-none fw-bold"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.attrValue(product, '#DisplayName')), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.attrValue(product, '#DisplayName')), 1))
                                    ]))
                                  : (col.dataField === 'VariantAttributes')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.variantAttributes, (variantAttribute, idx) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: idx,
                                              class: "badge bg-light text-dark border",
                                              innerHTML: 
                            variantAttribute.attributeName +
                            ': ' +
                            _ctx.attrValue(product, variantAttribute.attributeCode)
                          
                                            }, null, 8, _hoisted_24))
                                          }), 128))
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                          _createElementVNode("span", {
                                            class: "badge bg-primary text-white",
                                            style: {"font-size":"0.7rem"},
                                            innerHTML: 
                            group.attributeName + ': ' + _ctx.attrValue(product, group.attributeCode)
                          
                                          }, null, 8, _hoisted_26)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.attrValue(product, col.dataField)), 1))
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.products, (product) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `mobile-${group.attributeCode}-${product.productId}`,
                      class: "card mb-3 border"
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          (_ctx.componentOptions.showImages !== false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                (product.images?.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      _createElementVNode("img", {
                                        src: product.images[0].thumbnailUrl,
                                        class: "img-fluid rounded",
                                        style: {"width":"100%","height":"100%","object-fit":"contain","border":"1px solid #dee2e6"}
                                      }, null, 8, _hoisted_33)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              (product.productId)
                                ? (_openBlock(), _createBlock(_component_Clickable, {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.details(product)),
                                    class: "text-decoration-none fw-bold text-break"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.attrValue(product, '#DisplayName')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.attrValue(product, '#DisplayName')), 1))
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("span", {
                                class: "badge bg-primary text-white",
                                style: {"font-size":"0.7rem"},
                                innerHTML: 
                          group.attributeName + ': ' + _ctx.attrValue(product, group.attributeCode)
                        
                              }, null, 8, _hoisted_41)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.variantAttributes, (variantAttribute, idx) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: idx,
                                class: "badge bg-light text-dark border",
                                style: {"font-size":"0.7rem"},
                                innerHTML: 
                        variantAttribute.attributeName +
                        ': ' +
                        _ctx.attrValue(product, variantAttribute.attributeCode)
                      
                              }, null, 8, _hoisted_44))
                            }), 128))
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentOptions.columns, (col, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "mb-2"
                          }, [
                            (col.dataField !== 'ProductName' && col.dataField !== 'VariantAttributes')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  _createElementVNode("small", _hoisted_46, _toDisplayString(col.caption) + ":", 1),
                                  (col.cellTemplate)
                                    ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                        key: 0,
                                        template: col.cellTemplate,
                                        "template-props": {
                        col,
                        group,
                        item: product,
                        instance: _ctx.instance,
                        t: _ctx.t,
                        attrValue: _ctx.attrValue,
                        details: _ctx.details,
                      }
                                      }, null, 8, ["template", "template-props"]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.attrValue(product, col.dataField) || '-'), 1))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}